import type { Role } from '@elecmap/api/src/ram.d'
import { listEmployeeRole, updateEmployeeName, updateEmployeeRole } from '@elecmap/api/src/ram'
import { message } from 'ant-design-vue'
import { reactive, ref, watch } from 'vue'
import { notificationSuccess } from '@elecmap/shared/src/utils/notification'

export function useRoleList(roleType: string) {
  const memberPermissionState = reactive({
    visible: false,
    editingUserId: 0,
    editingUserName: '',
    memberPermission: 0,
  })

  const roleList = ref<Role[]>([])

  watch(
    () => memberPermissionState.editingUserId,
    id => {
      if (!id) return
      listEmployeeRole(id).then(data => {
        const role = data.find(r => r.description === roleType)
        memberPermissionState.memberPermission = role?.roleId ?? 251
        memberPermissionState.visible = true
      })
    },
  )

  async function updateRole() {
    const cmd = roleList.value
      .filter(r => r.description !== roleType)
      .map(item => ({
        roleId: item.roleId,
        roleName: item.roleName,
        delegate: false,
      }))
    cmd.push({
      roleId: memberPermissionState.memberPermission,
      roleName: '',
      delegate: false,
    })
    await updateEmployeeRole({
      userId: memberPermissionState.editingUserId,
      employeeRoleList: cmd,
    })
    notificationSuccess('操作成功')
    memberPermissionState.visible = false
    memberPermissionState.editingUserId = 0
  }

  async function updateRoleDirectly(userId: number, permissionId: number) {
    const cmd = roleList.value
      .filter(r => r.description !== roleType)
      .map(item => ({
        roleId: item.roleId,
        roleName: item.roleName,
        delegate: false,
      }))
    cmd.push({
      roleId: permissionId,
      roleName: '',
      delegate: false,
    })
    await updateEmployeeRole({
      userId,
      employeeRoleList: cmd,
    })
    notificationSuccess('操作成功')
    memberPermissionState.visible = false
    memberPermissionState.editingUserId = 0
  }

  return { memberPermissionState, updateRole, updateRoleDirectly }
}
